<table class="orari" cellspacing="2" cellpadding="2" id="25afternoon">
    <tr>
        <th class="schedule" colspan="2">
            <font size="+1">
                <b> September 25th (afternoon) - Scientific Session</b>
                <br>
                <i class="location">Centro D. Menichella, Largo Guido Carli 1, Frascati (Rome)</i>
            </font>
        </th>
    </tr>
    <!-- MINI SESSION: BOOLEAN FUNCTIONS -->
    <tr>
        <td class="schedule"> 14:00<br>15:20 </td>
        <td>
            <em><b class="mini-session"> Mini-session: Boolean functions </b></em>
            <br>
            The focus of this mini-session is the precise design of symmetric
            cryptosystems, in order to have them provably secure.
            Boolean functions represent a key ingredient in the cryptosystem design.
            This mini-session will start with a keynote by Prof.
            Emeritus Claude Carlet, considered by many the world expert on Boolean functions.
            <br>
            <br>
            <ol>
                <li>
                    <b class="invited-speaker">Claude Carlet</b>, University of Paris VIII and LAGA (France)<br>
                    Invited talk: <i>Quadratic-like balanced functions and permutations</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/17_la2um2DZdX36kYLGrWY7tFn4IhGq_-">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        <i>
                            The so-called (n,m)-functions have very nice properties when quadratic, which for instance
                            ease the
                            study of their
                            almost perfect nonlinearity. But quadratic functions are weak against some other attacks. It
                            is then
                            important to study strict superclasses sharing some of these properties. In particular, when
                            the
                            block ciphers have a structure of substitution-permutation network (SPN), the substitution
                            boxes
                            must be
                            permutations (m=n). <br>
                            It is then essential to study superclasses of quadratic functions within the class of
                            balanced
                            functions. We shall introduce and study such a superclass, that of "quadratic-like balanced
                            functions"
                            ("permutations" when m=n).
                        </i>
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Augustine Musukwa</b>, University of Trento (Italy)<br>
                    <i>On second-order derivatives of Boolean functions and cubic APN permutations in even dimension</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/17hwz23vWZ5WMW5Q8fUY9x_ew1HNA_xVp">slides</a>)<details>
                        <summary>
                            Abstract
                        </summary>
                        The big APN problem is one of the most important challenges in the theory of Boolean functions,
                        i.e.
                        finding
                        a new APN permutation in even dimension. Among this class of functions, those with the lowest
                        possible
                        degree are cubic. Yet, none has been found so far. In this paper, we introduce new parameters
                        for
                        Boolean
                        functions and for vectorial Boolean functions, mostly derived from the behavior of their
                        second-order
                        derivatives. These parameters are particularly relevant for small-degree functions. They allow
                        studying
                        bent, semi-bent and APN functions of degrees two and three. In particular, they allow tackling
                        the big
                        APN
                        problem for cubic permutations.
                    </details>
                </li>
            </ol>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 15:20<br>15:40 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <!-- MINI SESSION: PROTOCOLS -->
    <tr>
        <td class="schedule"> 15:40<br>17:00 </td>
        <td>
            <em><b class="mini-session"> Mini-session: Protocols and Zero-Knowledge </b></em>
            <br>
            This mini-session focusses on the analysis and design of cryptographic protocols.
            Zero-knowledge proofs are a fundamental tool in the design of many of them, and have a wide range of
            applications.
            This mini-session will start with a keynote by
            Daniele Venturi, Full Professor at La Sapienza, Rome.
            <br>
            <br>
            <ol>
                <li>
                    <b class="invited-speaker">Daniele Venturi</b>, University of Roma La Sapienza (Italy)<br>
                    Invited talk: <i>20 Years of Leakage-Resilient Cryptography</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1yBCHmiJea_8xoRqbwtfrZIyHLwjtrlK8">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        <i>
                            Cryptographic schemes are usually analyzed under the assumption that the underlying secrets
                            are
                            fully hidden from the adversary. Unfortunately, history has taught us that many (otherwise
                            provably
                            secure)
                            cryptosystems can be spectacularly broken by exploiting physical phenomena (the so-called
                            side-channel
                            attacks) resulting in partial information leakage about the underlying secret keys.
                            <br>
                            Leakage-resilient cryptography aims at closing the above gap by designing cryptosystems with
                            provable
                            guarantees even in the presence of attackers running different forms of side-channel
                            attacks. This talk
                            surveys the most important techniques behind leakage-resilient cryptography, since its
                            introduction in
                            the
                            seminal works by Ishai, Sahai and Wagner (CRYPTO 2003) and Micali and Reyzin (TCC 2004).
                        </i>
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Delaram Kahrobaei</b>, City University of New York (USA) <br>
                    <b class="normal-speaker">Ludovic Perret</b>, Sorbonne University & LIP6 (France) <br>
                    <b class="normal-speaker">Martina Vigorito</b>, University of Salerno (Italy) <br>
                    <i>Security Analysis of ZKPoK based on MQ problem in the Multi-Instance Setting</i>
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        We will investigate the Multivariate Quadratic (MQ) problem, a well-known post-quantum hard
                        problem,
                        and introduce a new variant called the Differential Multivariate Quadratic Homogeneous (DiffMQH)
                        problem. We present a polynomial-time algorithm that solves the DiffMQH problem by reducing it
                        to finding collisions in a quadratic system. Our analysis demonstrates that while the MQ problem
                        is challenging, the DiffMQH problem is significantly easier to solve, suggesting that this
                        approach may not be secure for practical cryptographic applications.
                    </details>
                </li>
            </ol>
        </td>
    </tr>
</table>


<table class="orari" cellspacing="2" cellpadding="2" id="25evening">
    <tr>
        <th class="schedule" colspan="2">
            <font size="+1">
                <b> September 25th (evening) - Social Event</b>
                <br>
                <i class="location">Location: <a href="https://www.satiricus.it/"><b>Satiricus</b></a>, Via dei
                    Corridori 58, Roma</i>
            </font>
        </th>
    </tr>
    <tr>
        <td class="schedule"> 20:30</td>
        <td>
            <em> Social Dinner </em>
            <br>
            <br>
            <a mat-button href="/cifris24/dinner" class="btn-showmore">
                More information
            </a>
        </td>
    </tr>
</table>


<hr>
<h2>September 26th</h2>

<table class="orari" cellspacing="2" cellpadding="2" id="26morning">
    <tr>
        <th class="schedule" colspan="2">
            <font size="+1">
                <b> September 26th (morning) - Scientific Session</b>
                <br>
                <i class="location">Centro D. Menichella, Largo Guido Carli 1, Frascati (Rome)</i>
            </font>
        </th>
    </tr>
    <!-- MINI SESSION: PQ -->
    <tr>
        <td class="schedule"> 10:00<br>11:40 </td>
        <td>
            <em><b class="mini-session"> Mini-session: Post-Quantum Cryptography </b></em>
            <br>
            The focus of this mini-session are recent results on the design of ciphers
            that may resist attacks performed with quantum computers.
            Indeed, the quantum threat is among the most feared in modern cryptography.
            This mini-session will start with a keynote by Prof. Simona Samardjiska, a
            young brilliant expert in this controversial field.
            <br>
            <br>
            <ol>
                <li>
                    <b class="invited-speaker">Simona Samardjiska</b>, Radboud University (Netherlands)<br>
                    Invited talk: <i>Algorithms for solving the matrix code equivalence problem</i>
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        <i>
                            In the past few years, there has been an increased interest in hard equivalence problems,
                            especially with NIST's announcement of a fourth round for new designs of digital signatures.
                            On a high level, such a problem can be defined as follows: Given two algebraic objects,
                            find - if any - an equivalence that maps one object into the other.
                            Several instantiations have been considered for cryptographic purposes, for example -
                            Isomorphism of polynomials (Pattarin '96), Code equivalence (Biasse et al. '20),
                            Matrix Code equivalence (Chou et al. '22), Alternating trilinear form equivalence
                            (Tang et al.'22), Lattice isomorphism (Ducas & van Woerden '22). All of these problems
                            are believed to be hard even for quantum adversaries. Conveniently, they can generically
                            be used to build a Sigma protocol and further a post-quantum secure signature using the
                            Fiat-Shamir transform.
                            <br>
                            In this talk I will make a broad overview of algorithms for solving the matrix code
                            equivalence
                            problem and how they can be applied to related problems. In particular, I will focus on
                            algebraic and graph-based algorithms which are currently the state-of-the-art for solving
                            the
                            problem. I will further argue that clever combination of the two technics often leads to the
                            best,
                            and sometimes surprising results.
                        </i>
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Antonio J. Di Scala</b> and <b class="normal-speaker">Carlo Sanna</b>,
                    Polytechnic University of Turin (Italy)<br>
                    <i>Smaller public-keys for MinRank-based schemes</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1y5_im44nGyCD3rPUMkZ8ONfLTpf-YeMk">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        In this talk, we will explore the MinRank problem, a well-established problem in linear algebra
                        with significant relevance for post-quantum cryptography. We will focus on the search version of
                        MinRank, which involves finding a non-trivial linear combination of given matrices whose rank is
                        below a specified threshold. MinRank is particularly attractive for cryptographic applications
                        due to its foundation in linear algebra, its NP-completeness, and the absence of efficient
                        quantum algorithms that can solve it.
                        <br>
                        We will introduce a new key-generation algorithm for MinRank-based cryptographic schemes, which
                        we call KeyGen3. This algorithm significantly reduces the size of the public key compared to
                        existing methods, achieving a compression of about 50% relative to the current best approach,
                        KeyGen2. Additionally, we will provide a rigorous proof that the security of KeyGen3 is closely
                        related to that of KeyGen1, with a negligible security loss. Our results demonstrate that
                        KeyGen3 offers a highly efficient and secure method for public key compression in MinRank-based
                        cryptography.
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Delaram Kahrobaei</b>, City University of New York (USA) <br>
                    <b class="normal-speaker">Carmine Monetta</b>, <b class="normal-speaker">Maria Tota</b> and <b
                        class="normal-speaker">Martina Vigorito</b> University of Salerno (Italy)<br>
                    <b class="normal-speaker">Ludovic Perret</b>, Sorbonne University & LIP6 (France) <br>
                    <i>Investigation of Metabelian Platform Groups for Protocols Based on the (Simultaneous) Conjugacy
                        Search Problem</i>

                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1fgtc9BiY4oOVE0XlFtTom80SpY8crpCQ">slides</a>)<details>
                        <summary>
                            Abstract
                        </summary>
                        We will cover advancements in the field of group-based cryptography,
                        particularly focusing on the cryptanalysis of protocols using metabelian groups as the platform.
                        Building on previous work, we will generalize the Field-Based Attack (FBA) to demonstrate how
                        both the Conjugacy Search Problem (CSP) and Simultaneous Conjugacy Search Problem (SCSP) can be
                        cryptanalyzed for certain classes of metabelian groups of the form G=M⋉NG=M⋉N, where both MM and
                        NN are abelian. These groups naturally arise in linear algebra and ring theory.
                        <br>
                        Specifically, we will present two main results: a polynomial-time algorithm that breaks the
                        Commutator Key-Exchange Protocol (AAG) and the non-commutative Diffie-Hellman Key-Exchange
                        Protocol (Ko-Lee) for groups of this form. These results indicate that while metabelian groups
                        have been proposed as secure platforms for these protocols, certain families must be avoided due
                        to their vulnerability to efficient cryptanalysis.
                    </details>
                </li>
            </ol>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 11:40<br>12:00 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <!-- MINI SESSION: PUBLIC KEY -->
    <tr>
        <td class="schedule"> 12:00<br>13:00 </td>
        <td>
            <em><b class="mini-session"> Mini-session: Public-key cryptography </b></em>
            <br> In this session we discuss security and performance of (classical) public-key cryptography,
            which includes the most widely adopted cryptographic protocols in the Internet.
            <br>
            <br>
            <ol>
                <li>
                    <b class="normal-speaker">Giordano Santilli</b>, Agenzia per la Cybersicurezza Nazionale (Italy)
                    <br>
                    <b class="normal-speaker">Daniele Taufer</b>, KU Leuven (Belgium)<br>
                    <i>First-degree prime ideals of composite extensions</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1YWL_GrUg0kNRdAmN-fXB7mq9f2Cm3PhC">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        We will present our findings on first-degree prime ideals within composite
                        extensions of number fields. Building on the known methods for biquadratic fields, we generalize
                        the approach to composite fields of any degree, showing that first-degree prime ideals can be
                        effectively computed from norms in their minimal subfields. We demonstrate that this method
                        preserves the divisibility of principal ideals, with only rare exceptions. These results provide
                        a novel framework with significant implications for computational algebra, particularly in the
                        context of large extensions constructed from smaller fields.
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Marco Macchetti</b> and <b class="normal-speaker">Nils Amiet</b>, Kudelski
                    Group (Switzerland)<br>
                    <i>A Novel Related Nonce Attack for ECDSA</i>
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        We will introduce a novel cryptanalytic attack on the Elliptic Curve Digital Signature Algorithm
                        (ECDSA) that exploits complex polynomial relationships among nonces. Unlike previous attacks
                        that focused on linear relationships or simple biases in nonce generation, our approach
                        addresses cases where nonces are related through higher-degree algebraic equations, such as
                        those generated by quadratic or cubic congruential generators. We demonstrate how this attack
                        can retrieve the private key from a small set of signatures, broadening the scope of
                        vulnerabilities in ECDSA, including widely used implementations like secp256k1.
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Dmitrii Koshelev</b>, University of Lleida (Spain)<br>
                    <i>Application of Mordell-Weil lattices with large kissing numbers to acceleration of multiscalar
                        multiplication on elliptic curves</i>
                    (<a target="_blank" href="https://drive.google.com/file/d/1NkKQF8myYm4RMS5P1cCSZinNTgKWHkxR">
                        slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        In this presentation, we explore the use of Mordell–Weil (MW) lattices to accelerate
                        multi-scalar multiplication (MSM) on elliptic curves, specifically for curves with a j-invariant
                        of 0. MSM is a crucial yet computationally expensive operation in elliptic curve cryptography.
                        By leveraging MW lattices with large kissing numbers—indicative of high efficiency in evaluating
                        points—we can significantly enhance the performance of MSM. The focus is on utilizing these
                        lattices to optimize the generation of auxiliary points, particularly on j = 0 curves, where
                        their structure provides optimal conditions for reducing computational overhead in cryptographic
                        operations.
                    </details>
                </li>
            </ol>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 13:00<br>14:00 </td>
        <td><em> Lunch </em></td>
    </tr>
</table>



<table class="orari" cellspacing="2" cellpadding="2" id="26afternoon">
    <tr>
        <th class="schedule" colspan="2">
            <font size="+1">
                <b>September 26th (afternoon) - Scientific Session</b>
                <br>
                <i class="location">Centro D. Menichella, Largo Guido Carli 1, Frascati (Rome)</i>
            </font>
        </th>
    </tr>
    <!-- MINI SESSION: THEORY -->
    <tr>
        <td class="schedule"> 14:00<br>15:40 </td>
        <td>
            <em><b class="mini-session"> Mini-session: Theoretical cryptography </b></em>
            <br> The security of cryptosystems heavily depends on their mathematical foundations. In this
            mini-session we start with a keynote by Prof. Gregor Leander,
            managing editor of the journal IACR Transaction of Symmetric Cryptography,
            and then we present two advanced schemes that provide security even
            when computations are performed in a hostile environment.
            <br>
            <br>
            <ol>
                <li>
                    <b class="invited-speaker">Gregor Leander</b>, Ruhr-University Bochum (Germany)<br>
                    Invited talk: <i>Low Latency Designs: Primitives and Beyond</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1-QNCCVCAj9AxcBgMyIzHSgOP2tlWD1yB">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        In this talk I will explain the different cryptographic primitives that have been developed in
                        the area of
                        symmetric cryptography that allow encryption with a very small latency. Applications are in
                        particular
                        memory encryption or cache-randomization.
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Maria Ferrara</b>, <b class="normal-speaker">Paolo Santonastaso</b>,
                    <b class="normal-speaker">Antonio Tortora</b> and <b class="normal-speaker">Ferdinando Zullo</b>,
                    University of Campania (Italy)<br>
                    <i>Polynomial functional encryption schemes</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1BggD4eoj_QCpZYTSbX4-jF9GzfoBK_3a">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        In this talk, motivated by the construction of practically efficient functional encryption
                        scheme supporting
                        more than linear functionalities, we describe a new functional encryption scheme whose
                        functionalities are
                        polynomials. Such scheme is an extension of a known quadratic encryption scheme.
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Massimo Giulietti</b>, <b class="normal-speaker">Paolo Martinelli</b> and
                    <b class="normal-speaker">Marco Timpanella</b>, University of Perugia
                    (Italy)<br>
                    <i>Modern Techniques in Somewhat Homomorphic Encryption Schemes</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1LypgxKcGayiFNsVW_1xzNvqE_1R0c4Mj">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        This paper emphasizes the transition from classic SWHE schemes to modern approaches utilizing
                        lattice-based
                        problems, such as Learning With Errors (LWE). LWE, introduced by Regev, is central to both SWHE
                        and FHE due
                        to its security reductions to hard lattice problems, which are conjectured to be resistant to
                        quantum
                        attacks. This makes LWE-based schemes particularly attractive for constructing secure and
                        efficient
                        homomorphic encryption systems.
                    </details>
                </li>
            </ol>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 15:40<br>16:00 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <!-- MINI SESSION: PRACTICE -->
    <tr>
        <td class="schedule"> 16:00<br>16:40 </td>
        <td>
            <em><b class="mini-session"> Mini-session: Applied Cryptography </b></em>
            <br> The focus of this session is to show the importance of
            practical implementations of cryptography, while at the same
            time showing the deep link between theory and practice in this
            research field.
            <br>
            <br>
            <ol>
                <li>
                    <b class="normal-speaker">Francesco De Sclavis</b>,
                    <b class="normal-speaker">Giuseppe Galano</b>,
                    <b class="normal-speaker">Sara Giammusso</b>,
                    <b class="normal-speaker">Michela Iezzi</b>,
                    <b class="normal-speaker">Antonio Muci</b> and
                    <b class="normal-speaker">Matteo Nardelli</b>, Bank of Italy (Italy)
                    <br>
                    <b class="normal-speaker">Annalisa Cimatti</b> and <b class="normal-speaker">Marco Pedicini</b>,
                    Roma Tre University (Italy)
                    <br>
                    <i>Dynamic-FROST: Schnorr Threshold Signatures with a Flexible Committee</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/1yZtWHzSQlSSFM3G4XMZ8W5EDTk4ZxaOA">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        We will present Dynamic-FROST (D-FROST), an innovative extension of the FROST threshold
                        signature scheme, which allows for dynamic changes in the committee and threshold without
                        altering the group public key. By integrating FROST with CHURP, a Dynamic Proactive Secret
                        Sharing scheme, D-FROST enables flexible committee adjustments and proactive share updates. This
                        approach ensures continued security and confidentiality while avoiding the need for a central
                        dealer or repeated key generation. We demonstrate how D-FROST maintains EUF-CMA security and
                        provides a practical solution for evolving decentralized systems and blockchain applications.
                    </details>
                </li>
                <li>
                    <b class="normal-speaker">Fadi Barbara</b> and <b class="normal-speaker">Enrico Guglielmino</b>,
                    Polytechnic University of Turin (Italy) <br>
                    <b class="normal-speaker">Nadir Murru</b>, University of Trento (Italy) <br>
                    <b class="normal-speaker">Claudio Schifanella</b>, University of Turin (Italy) <br>
                    <i>BTLE: Atomic Swaps with Time-Lock Puzzles</i>
                    (<a target="_blank"
                        href="https://drive.google.com/file/d/16D7Ns_q-175mbW_UY-43znisTFfBePRl">slides</a>)
                    <details>
                        <summary>
                            Abstract
                        </summary>
                        In this talk, we introduce Broadcast Time-Lock Exchange (BTLE), a novel approach to cross-chain
                        communication leveraging time-lock puzzles. Our method builds upon Rivest’s time-lock puzzle
                        concept and extends it to a broadcast setting, enabling decentralized exchanges among multiple
                        participants without requiring prior acquaintance. We propose a decentralized matching algorithm
                        and a new type of time-lock puzzle based on Pell conics, which can be transformed into a
                        Verifiable Delay Function. Our solution includes a comparative analysis with existing methods,
                        an implementation of both the matching algorithm and exchange protocol, and a security proof in
                        the hybrid ideal/real world simulation. This work aims to enhance cross-chain transactions in
                        dynamic and decentralized environments.
                    </details>
                </li>
            </ol>
        </td>
    </tr>
</table>